<yc-alert alertClass="info"
  [message]="'CONFIG:textDragAndDropAFormComponent' | ycI18n: 'Drag and drop a form component'">
</yc-alert>